/* ATN Membership - Section 02: Benefits mobile slider */
/* On mobile the card grid becomes a horizontal slider. Arrows drive it and
   native touch swipe still works. Arrows are hidden on desktop via CSS.
   Re-inits on Shopify section load. */
(function () {
  function AtnMemBenefits(root) {
    if (!root || root.dataset.benInit === '1') return;
    root.dataset.benInit = '1';

    var viewport = root.querySelector('[data-benefits-viewport]');
    var prev = root.querySelector('[data-benefits-prev]');
    var next = root.querySelector('[data-benefits-next]');
    if (!viewport) return;

    function gap() {
      var g = parseInt(getComputedStyle(viewport).columnGap, 10);
      return isNaN(g) ? 0 : g;
    }

    function step() {
      var card = viewport.querySelector('.atn-mem-benefit');
      if (!card) return Math.round(viewport.clientWidth * 0.8);
      return Math.round(card.getBoundingClientRect().width + gap());
    }

    function update() {
      var max = viewport.scrollWidth - viewport.clientWidth - 1;
      var x = viewport.scrollLeft;
      if (prev) prev.toggleAttribute('disabled', x <= 0);
      if (next) next.toggleAttribute('disabled', x >= max);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        viewport.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        viewport.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-atn-mem-benefits]').forEach(AtnMemBenefits);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-atn-mem-benefits]');
    if (el) AtnMemBenefits(el);
  });
})();